import ConfigGeneral from '../config/general';

/* eslint-disable import/no-anonymous-default-export */
export default {
	components: {
		map: {
			mapLayer: 'Map layer',
		},
		mapFilter: {
			searchPrimary: 'Search',
			searchSecondary: 'Location or place name',
			searchPlaceholder: 'Type here',
			filterPrimary: 'Place type',
			filterSecondary: 'Filter by categories',
			dataPrimary: 'Data available',
			dataSecondary: 'Filter by available information',
		},
		mapLegend: {
			title: 'Legend',
			seaLevel: 'Sea level',
			belowSeaLevel: 'Below sea level',
			elevation100: '100 m elevation',
			elevation50: '50 m elevation',
			broadLeavedForest: 'Broad-leaved forest',
			coniferousForest: 'Coniferous forest',
			mixedForest: 'Mixed forest',
			naturalGrasslands: 'Natural grasslands',
			moorsAndHeathland: 'Moors and heathland',
			sclerophyllousVegetation: 'Sclerophyllous vegetation',
			transitionalWoodlandShrub: 'Transitional woodland-shrub',
			beachesDunesSands: 'Beaches, dunes, sands',
			inlandMarshes: 'Inland Marshes',
			peatBogs: 'Peat Bogs',
			saltMarshes: 'Salt Marshes',
			intertidalFlats: 'Intertidal Flats',
			motorway: 'Motorway',
			mainRoad: 'Main road',
			railway: 'Railway',
			administrativeBoundary: 'Administrative boundary',
			lakeAndWaterTank: 'Lake and water tank',
			forest: 'Forest',
			natureReserve: 'Nature reserve',
			grasslandAndMeadow: 'Grassland and meadow',
			pedestrianZone: 'Pedestrian zone',
			commericalArea: 'Commercial zone',
			industrialArea: 'Industrial zone',
		},
		placePopup: {
			imagesAvailable: 'image available',
			videosAvailable: 'video available',
			details: 'Details',
		},
		placeDetails: {
			overview: 'Overview',
			guide: 'Guide',
			reconstruction: 'Reconstruction',
			media: 'Media',
			placeType: 'Place type',
			altNames: 'Alternative name',
			location: 'Location',
			coordinates: 'Coordinates',
			openInNewWindow: 'Open in new window',
		},
	},
	app: {
		loadingError: 'Error while loading data',
		impressum: 'Impressum',
		close: 'Close',
	},
	global: {
		yes: 'Yes',
		no: 'No',
		photo: 'Photo',
		panoramaPhoto: 'Panorama photos',
		video: 'Video',
		guide: 'Guide',
		loading: 'Loading'
	},
	fancybox: {
		AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
		AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
		CLOSE: "Close",
		DOWNLOAD: "Download",
		ELEMENT_NOT_FOUND: "HTML Element Not Found",
		ERROR: "Something Went Wrong, Please Try Again Later",
		IFRAME_ERROR: "Error Loading Page",
		IMAGE_ERROR: "Image Not Found",
		MODAL: "You can close this modal content with the ESC key",
		NEXT: "Next",
		PREV: "Previous",
		TOGGLE_FULLSCREEN: "Toggle full-screen mode",
		TOGGLE_SLIDESHOW: "Toggle slideshow",
		TOGGLE_THUMBS: "Toggle thumbnails",
		TOGGLE_ZOOM: "Toggle zoom level",
	},
	filters: {
		state: {
			label: 'State',
			all: 'All',
			active: 'Active',
			inactive: 'Inactive',
		},
	},
	resources: {
		placetypes: {
			name: 'Helyszín típusok',
			fields: {
				id: '#',
				name: 'Név',
				name_display: 'Név',
				state: 'Aktív',
				ordering: 'Rendezés',
				icon: 'Ikon (SVG)'
			}
		},
		phototypes: {
			name: 'Fénykép típusok',
			fields: {
				id: '#',
				name: 'Név',
				name_display: 'Név',
				state: 'Aktív',
				ordering: 'Rendezés',
			}
		},
		modeltypes: {
			name: '3D modell típusok',
			fields: {
				id: '#',
				name: 'Név',
				name_display: 'Név',
				state: 'Aktív',
				ordering: 'Rendezés',
			}
		},
		users: {
			name: 'Felhasználók',
			fields: {
				id: '#',
				name: 'Név',
				email: 'Email cím',
				password: 'Jelszó',
			}
		},
		places: {
			name: 'Helyszínek',
			fields: {
				id: '#',
				name: 'Megnevezés',
				name_display: 'Megnevezés',
				alt_name: 'Alternatív megnevezés',
				location: 'Település',
				location_display: 'Település',
				guide_intro: 'Rövid leírás',
				guide: 'Ismertető',
				place_type_ids: 'Típus',
				coordinate_x: 'Hosszúsági fok',
				coordinate_y: 'Szélességi fok',
				state: 'Aktív',
				ordering: 'Rendezés',
				source: 'Szolgáltató',
				video_id: 'Videó ID',
				caption: 'Cím',
				reconstruction: 'Rekonstrukció',
				model_type_id: 'Típus',
				preview: 'Előnézeti képfájl',
				model: 'Modellfájl',
				models: '',
				videos: '',
				previewInput: 'Húzd ide az előnézeti képfájlt, vagy kattints a kiválasztáshoz',
				modelInput: 'Húzd ide a modellfájlt, vagy kattints a kiválasztáshoz',
			},
			tab: {
				summary: 'Általános',
				photos: 'Fényképek',
				videos: 'Videók',
				models: '3D modellek',
			},
		},
		settings: {
			name: 'Beállítások',
			fields: {
				page_title: 'Fejléc szövege',
				sidebar_title: 'Oldalsáv címe',
				sidebar_text: 'Oldalsáv bevezető szövege',
				footer_text: 'Lábléc szövege',
				impressum: 'Impresszum tartalma',
			}
		},
	},
	ra: {
		action: {
			add_filter: 'Filter',
			add: 'Add',
			back: 'Back',
			bulk_actions: '%{smart_count} selected',
			cancel: 'Cancel',
			clear_input_value: 'Clear',
			clone: 'Copy',
			create: 'New',
			delete: 'Delete',
			edit: 'Edit',
			export: 'Export',
			list: 'List',
			refresh: 'Refresh',
			remove_filter: 'Clear filter',
			remove: 'Delete',
			save: 'Save',
			save_and_list: 'Save & back',
			save_and_add: 'Save & new',
			show: 'Show',
			sort: 'Sort by the column',
			undo: 'Undo',
			bulk_disable_state: 'Disable',
			bulk_enable_state: 'Enable',
			change_ordering: 'Change order',
			unselect: 'Deselect',
			confirm: 'Confirm',
			search: 'Search',
		},
		locales: ConfigGeneral.locales.reduce((obj, item) => {
			return {
				...obj,
				[item.code]: item.name,
			};
		}, {}),
		boolean: {
			true: 'Yes',
			false: 'No',
		},
		state: {
			active: 'Enabled',
			inactive: 'Disabled',
		},
		page: {
			create: 'Create %{name}',
			dashboard: 'Dashboard',
			edit: '%{name} #%{id}',
			error: 'Error',
			list: '%{name} list',
			loading: 'Loading',
			not_found: 'Not found',
			show: '%{name} #%{id}',
			empty: 'There are no items',
			invite: 'Create one with the button below.',
		},
		input: {
			file: {
				upload_several: 'Drag files here, or click to select them.',
				upload_single: 'Drag a file here, or click to select it.',
			},
			image: {
				upload_several: 'Drag images here, or click to select them.',
				upload_single: 'Drag an image here, or click to select it.',
			},
			references: {
				all_missing: 'Reference data are missing',
				many_missing: 'One or more reference data are missing',
				single_missing: 'One reference data is missing',
			},
		},
		message: {
			about: 'About',
			are_you_sure: 'Are you sure?',
			bulk_delete_content: 'Are sure you would like to delete? |||| Are you sure you would like to delete %{smart_count} items?',
			bulk_delete_title: 'Delete item |||| Delete %{smart_count} items',
			delete_content: 'Are sure you would like to delete?',
			delete_title: 'Delete #%{id}',
			details: 'Details',
			error: 'Client error',
			invalid_form: 'The form is invalid. Please check the errors!',
			loading: 'Loading',
			no: 'No',
			not_found: 'The requested page was not found.',
			yes: 'Yes',
			bulk_disable_state: 'Are you sure you would like to disable the item? |||| Are you sure you would like to disable %{smart_count} items?',
			bulk_enable_state: ' Are you sure you would like to enable the item? |||| Are you sure you would like to enable %{smart_count} items?',
		},
		navigation: {
			no_results: 'No results.',
			no_more_results: 'No more results.',
			page_out_of_boundaries: '%{page}. page does not exists',
			page_out_from_end: 'Page out of boundary',
			page_out_from_begin: 'Page out of boundary',
			page_range_info: '%{offsetBegin}-%{offsetEnd}, totally %{total}',
			next: 'Next',
			prev: 'Prev',
			page_rows_per_page: 'On one page:',
			skip_nav: 'Skip to content',
		},
		auth: {
			username: 'Username',
			password: 'Password',
			sign_in: 'Login',
			sign_in_error: 'Login error. Please try again.',
			logout: 'Logout',
			user_menu: 'Felhasználó',
		},
		notification: {
			updated: 'Changes saved |||| %{smart_count} items updated',
			created: 'Item created',
			deleted: 'Item deleted |||| %{smart_count} items deleted',
			bad_item: 'Incorrect element',
			item_doesnt_exist: 'The item does not exist',
			http_error: 'Communication error',
			data_provider_error: 'Data provider error',
			canceled: 'Action cancelled',
			state_updated: 'State updated',
			bulk_disable_state: 'Item disabled |||| %{smart_count} items disabled',
			bulk_enable_state: 'Item enabled |||| %{smart_count} items enabled',
			ordering_updated: 'Ordering updated',
		},
		validation: {
			required: 'Required',
			minLength: 'Minimum %{min} characters',
			maxLength: 'Maximum %{max} characters',
			minValue: 'At least %{min}',
			maxValue: 'At most %{max}',
			number: 'Must be a number',
			email: 'Invalid format',
			oneOf: 'One of: %{options}',
			regex: 'Must match the following pattern (regexp): %{pattern}',
		},
		fileManager: {
			behaviourAlert: 'A módosítások - beleértve a fájlok feltöltését - a mentés gomb megnyomását követően lépnek életbe.',
			info: 'Húzd a fájlokat az alábbi területre, vagy kattints a fájlok hozzáadása gombra. A sorrend áthúzással módosítható.',
			selectFiles: 'Fájlok hozzáadása',
			dragOverText: 'Ejtsd ide a fájlokat',
			caption: 'Cím',
			deleteConfirm: {
				title: 'Biztos törölni szeretnéd a fájlt?',
				uploadedInfo: 'A fájl már fel van töltve a szerverre, a mentés gomb megnyomását követően fogjuk törölni.',
				notUploadedInfo: 'A fájl még nincs feltöltve a szerverre, eltávolítjuk a listából.',
				delete: 'Törlés',
				cancel: 'Mégse',
			}
		}
	},
};